import { format, parseISO } from 'date-fns';

export const monthFormat = 'MMM yyyy';
export const displayDateFormat = 'MM/dd/yy';
export const displayDateFormatWithDay = 'MMM d, yyyy';
export const isoDateFormat = 'yyyy-MM-dd';

export const convertDate = (date: string, dateFormat: string) => format(parseISO(date), dateFormat).toUpperCase();
